import styled from "styled-components";
import {COLORS} from "../../../shared/consts";
import {toRem} from "shared/helpers";

export const Table = styled.div`
  width: 100%;
  background-color: ${COLORS.BG.SURFACE2};
  padding: ${toRem(24)};
  border-radius: ${toRem(16)};
  cursor: pointer;

  @media (max-width: 768px) {
    padding: ${toRem(16)};
    border-radius: ${toRem(12)};
  }
`;

export const Row = styled.div<{ header?: boolean }>`
  display: flex;
  align-items: end;
  gap: 0;
  padding-top: ${toRem(10)};
  padding-bottom: ${toRem(10)};
  font-size: ${toRem(16)};
  color: ${COLORS.FG.DEFAULT};

  ${({ header }) =>
    header &&
    `
    padding-top: 0;
    padding-bottom: ${toRem(12)};
  `}

  @media (max-width: 768px) {
    font-size: ${toRem(14)};
    padding-top: ${toRem(8)};
    padding-bottom: ${toRem(8)};

    ${({ header }) =>
      header &&
      `
      & > *:nth-child(2),
      & > *:nth-child(3),
      & > *:nth-child(4),
      & > *:nth-child(5),
      & > *:nth-child(6),

      & > *:nth-child(1) { flex: 1 1 60%; }
    `}
  }
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-variant-numeric: tabular-num;

  &:nth-child(1) {
    flex: 0 0 20%;
  }
  &:nth-child(2) {
    flex: 0 0 30%;
  }
  &:nth-child(3) {
    flex: 0 0 10%;
  }
  &:nth-child(4) {
    flex: 0 0 14%;
  }
  &:nth-child(5) {
    flex: 0 0 14%;
  }
  &:nth-child(6) {
    flex: 0 0 12%;
  }

  &:nth-child(3),
  &:nth-child(4),
  &:nth-child(5),
  &:nth-child(6),
  &:nth-child(7) {
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    &:nth-child(3),
    &:nth-child(5),
    &:nth-child(6),
    &:nth-child(7) {
      display: none;
    }

    &:nth-child(1) {
      flex: 1 1 40%;
      justify-content: flex-start;
    }
    &:nth-child(2) {
      flex: 0 0 30%;
      justify-content: flex-start;
    }
    &:nth-child(4) {
      flex: 0 0 30%;
      justify-content: flex-end;
    }
  }
`;

export const Part = styled(Cell)`
  color: ${COLORS.FG.SOFT};
  font-weight: 500;
  justify-content: flex-start !important;
`;

export const Muted = styled.span`
  font-size: ${toRem(12)};
  color: ${COLORS.FG.SOFT};
`;

export const UfBlock = styled(Cell)`
  display: flex;
  gap: ${toRem(4)};

  @media (max-width: 768px) {
    display: none;
  }
`;

export const IconBlock = styled(Cell)`
  display: flex;
  gap: ${toRem(10)};

  @media (max-width: 768px) {
    gap: ${toRem(8)};
  }
`;

export const HeaderTitle = styled(Cell)`
  color: ${COLORS.FG.SOFT};
  font-size: ${toRem(12)};
`;

export const HeaderMainTitle = styled(Cell)`
  font-weight: bold;
  font-size: ${toRem(18)};

  @media (max-width: 768px) {
    font-size: ${toRem(16)};
  }
`;

export const Temp = styled.span`
  color: ${COLORS.FG.DEFAULT};
  font-size: ${toRem(16)};
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: ${toRem(15)};
  }
`;

export const Desc = styled.span`
  color: ${COLORS.FG.SOFT};
  font-size: ${toRem(12)};

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Divider = styled.div`
  height: ${toRem(20)};
  max-height: 1px;
  background: ${COLORS.BORDER.MUTED};
  margin-top: ${toRem(12)};
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const FooterStats = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${toRem(10)};
    gap: ${toRem(12)};
  }
`;

export const Stat = styled.div`
  display: flex;
  align-items: center;
  gap: ${toRem(6)};
  color: ${COLORS.FG.SOFT};
  font-size: ${toRem(14)};

  svg {
    width: ${toRem(18)};
    height: ${toRem(18)};
    opacity: 0.8;
  }
`;

export const StatMuted = styled.span`
  color: ${COLORS.FG.SOFT};
  font-size: ${toRem(14)};
`;
